import React, { useContext, useState } from "react";
import { AppBar, Toolbar, IconButton, Typography, Drawer, Box, useTheme, useMediaQuery, Menu, MenuItem, Avatar, Button } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Sidebar from "./Sidebar";
import {  useData } from "../ContextApi/ContextProvider";
import RotatingLinesLoader from "./ReusableComponent.js/Loader";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import LogoutIcon from "@mui/icons-material/Logout";

const drawerWidth = 248;

export default function MainLayout({ children }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { loader,globalData } = useData(); 
  // User email (from JWT, here just mock for demo)
  const details = JSON.parse(localStorage.getItem("details"));
  const handleMenu = (e) => setAnchorEl(e.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const handleLogout = () => {
    localStorage.removeItem("jwt_token");
    window.location.href = "/login";
  };
  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f4f7fb" }}>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          bgcolor: "rgba(255,255,255,0.92)",
          color: "#111827",
          borderBottom: "1px solid rgba(148, 163, 184, 0.22)",
          boxShadow: "0 10px 30px rgba(15, 23, 42, 0.06)",
          backdropFilter: "blur(14px)",
        }}
      >
        <Toolbar sx={{ minHeight: { xs: 60, sm: 64 }, px: { xs: 2, sm: 3 } }}>
          {isMobile && (
            <IconButton color="inherit" edge="start" onClick={() => setMobileOpen(true)} sx={{ mr: 2 }}>
              <MenuIcon />
            </IconButton>
          )}
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 900, letterSpacing: 0, color: "#0f172a", lineHeight: 1 }}>
              KonnectFBR
            </Typography>
            <Typography sx={{ display: { xs: "none", sm: "block" }, color: "#64748b", fontSize: 12, fontWeight: 700, mt: 0.35 }}>
              Digital invoice compliance workspace
            </Typography>
          </Box>
          {globalData && (
          <Typography
            component="span"
            sx={{
              mr: 1.5,
              px: 1.5,
              py: 0.6,
              borderRadius: 999,
              bgcolor: globalData.is_prod_token === 1 ? "#dcfce7" : "#dbeafe",
              color: globalData.is_prod_token === 1 ? "#047857" : "#1d4ed8",
              fontSize: 13,
              fontWeight: 800,
              letterSpacing: 0,
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            {globalData.is_prod_token===1?"Production":"Sandbox"}
          </Typography>
        )}
        <Button
        color="inherit"
        startIcon={
          <Avatar
            sx={{
              width: 28,
              height: 28,
              bgcolor: "linear-gradient(135deg, #dbeafe, #e0e7ff)",
              color: "#1d4ed8",
              fontSize: 14,
              fontWeight: 800,
            }}
          >
            {details?.detail?.full_name?.[0]?.toUpperCase()}
          </Avatar>
        }
        endIcon={<ArrowDropDownIcon />}
        onClick={handleMenu}
        sx={{
          border: "1px solid rgba(148, 163, 184, 0.25)",
          borderRadius: 2,
          px: 1.25,
          py: 0.7,
          textTransform: "none",
          fontWeight: 700,
          color: "#374151",
          bgcolor: "#fff",
          boxShadow: "0 6px 18px rgba(15, 23, 42, 0.05)",
          "&:hover": { bgcolor: "#f8fafc", borderColor: "#cbd5e1" },
        }}
      >
        {details?.detail?.full_name}
      </Button>

      <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={handleClose}>
        <MenuItem onClick={handleLogout}>
          <LogoutIcon sx={{ mr: 1, fontSize: 20 }} /> Logout
        </MenuItem>
      </Menu>
        </Toolbar>
      </AppBar>
      {/* Sidebar */}
      <Box
        component="nav"
        sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
        aria-label="sidebar"
      >
        {isMobile ? (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={() => setMobileOpen(false)}
            ModalProps={{ keepMounted: true }}
            sx={{
              "& .MuiDrawer-paper": { width: drawerWidth, borderRight: 0 },
            }}
          >
            <Sidebar onNavigate={() => setMobileOpen(false)} />
          </Drawer>
        ) : (
          <Drawer
            variant="permanent"
            open
            sx={{
              "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box", borderRight: 0 },
            }}
          >
            <Sidebar />
          </Drawer>
        )}
      </Box>
      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 3 },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          background: "radial-gradient(circle at top left, rgba(37, 99, 235, 0.08), transparent 28%), linear-gradient(180deg, #f8fafc 0%, #f3f6fb 100%)",
          minHeight: "100vh",
          mt: { xs: "60px", sm: "64px" },
          position: "relative",
        }}
      >
        {children}

        {loader && (
          <Box
               sx={{
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        bgcolor: "rgba(255,255,255,0.6)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        pointerEvents: "all",
      }}

          >
<RotatingLinesLoader/>
          </Box>
        )}
      </Box>

    </Box>
  );
}
